import React from 'react';
import PropTypes from 'prop-types';

import IdentityStore from 'stores/IdentityStore';

import AccountManageMenu from 'components/nav/authenticated/mobile/AccountManageMenu';
import MobileMenuBack from 'components/nav/shared/MobileMenuBack';
import PenNameList from 'components/nav/shared/PenNameList';

class PenNamesMenu extends React.Component {
  static propTypes = {
    transitionToMenu: PropTypes.func.isRequired,
  };

  static menuName = 'penNames';

  constructor(props) {
    super(props);
    this.handleManageAccountClick = this.handleManageAccountClick.bind(this);
  }

  handleManageAccountClick() {
    this.props.transitionToMenu(AccountManageMenu.menuName);
  }

  render() {
    return (
      <ul className="nav navbar-nav">
        <li><MobileMenuBack callback={this.handleManageAccountClick} stringID="AA_Manage_Account" /></li>
        <PenNameList identities={IdentityStore.getState().identities} className="nav navbar-nav" isMobile />
      </ul>
    );
  }
}

export default PenNamesMenu;
